import React from "react";
import { _getBaseUrl } from "../utils/helper";

const Pagination = ({ totalPages, page, ...props }) => {
  const isPrevBtnDisabled = page <= 1;
  const isNextBtnDisabled = page >= totalPages;

  return totalPages <= 1 ? null : (
    <div className="pagination flex items-center gap-4">
      <button
        className={`btn-pager btn-pager-prev bg-cirBlack w-20 h-12 flex items-center justify-center rounded-full hover:opacity-80 disabled:opacity-30 ${
          isPrevBtnDisabled ? "disabled" : ""
        }`}
        disabled={isPrevBtnDisabled}
        onClick={() => props.setPage(page - 1)}
      >
        <img
          src={_getBaseUrl(
            "src/assets/inspiratiepunten/icon-pagi-prev.svg",
            true
          )}
          alt="previous arrow"
        />
      </button>
      {!props.hidePageIndex && (
        <div className="page-index">{`${page} van ${totalPages}`}</div>
      )}
      <button
        className={`btn-pager btn-pager-next bg-cirBlack w-20 h-12 flex items-center justify-center rounded-full hover:opacity-80 disabled:opacity-30 ${
          isNextBtnDisabled ? "disabled" : ""
        }`}
        disabled={isNextBtnDisabled}
        onClick={() => props.setPage(page + 1)}
      >
        <img
          src={_getBaseUrl(
            "src/assets/inspiratiepunten/icon-pagi-next.svg",
            true
          )}
          alt="next arrow"
        />
      </button>
    </div>
  );
};

export default Pagination;
